import { reloadicons } from './svg.js';
import { showOverlay, hideOverlay, validateForm, pageLoadingOff, pageLoadingOn, setZipcodeTypingFormatter } from './utilities.js';
import { dispatchAddPaymentInfoEvent, dispatchAddShippingInfoEvent} from './events';
import { loadCardForms, loadWallets } from './payments.js';
import '../../themes/checkout/2/checkout.css'
import Modal from 'bootstrap/js/dist/modal'


jQuery(function () {

	/** 
	* Contrato no checkout 
	*/
	$('.checkout .informativo a').click(function () {
		$("#contrato-ecommerce").toggle();
		if ($("#contrato-ecommerce").css("display") == "block") {
			$('html, body').animate({
				scrollTop: $(".checkout .informativo").offset().top + 100
			}, 600);
		}
	});

	// Preenchimento automatico do cadastro apos login social
	if ($('input[name="social_name"]').length > 0) {

		// Solicita o formulario de cadastro a API
		$.ajax({
			type: "POST",
			url: "",
			data: "identificacao=1&register=ok",
			dataType: "json",
			success: function (json) {
				$("#checkout-user").html(json.html);
				// Seta email e nome com base no retorno do login social
				var email = $('input[name="social_email"]').val();
				var name = $('input[name="social_name"]').val();
				// alert("email: " + email + "		name: " + name);
				$('input[name="full_name"]').val(name);
				$('input[name="email[]"]').val(email);
				// Cursor no primeiro campo obrigatorio vazio (normalmente o CPF)
				var vazio = $('#form-person-insert .required').filter(function () { return !$(this).val(); }).first();
				if (vazio.length) {
					vazio[0].scrollIntoView({ block: 'center' });
					vazio.trigger('focus');
				}
			}
		});


	};

	$(document).on("click", "form#form-cielo button[type=submit]", function (event) {
		pageLoadingOn();
		const recaptcha = $(this).attr("data-recaptcha");
		const paymentId = $(this).attr("data-formPaymentId");
		if (recaptcha != undefined) {
			const form = $(this).closest(`form[data-recaptcha]`);
			const check = validateForm(form);
			if (!check){
				pageLoadingOff();
				return false;
			}
			event.preventDefault();
			// Se tiver PAGAR.ME
			if (paymentId != undefined && paymentId == 70) {
				try {
					var validade = $(form).find("#cartaoValidade").val().split("/");
					var creditCard = new PagarMe.creditCard();
					creditCard.cardHolderName = $(form).find("#portadorNome").val();
					creditCard.cardExpirationMonth = validade[0];
					creditCard.cardExpirationYear = validade[1];
					creditCard.cardNumber = $(form).find("#cartaoNumero").val();
					creditCard.cardCVV = $(form).find("#cartaoCodigoSeguranca").val();

					var fieldErrors = creditCard.fieldErrors();
					var hasErrors = false;
					for (var field in fieldErrors) {
						alert(fieldErrors[field]);
						hasErrors = true;
						break;
					}

					if (!hasErrors) {
						creditCard.generateHash(function (cardHash) {
							$('input[name=card_hash]').val(cardHash);
							if (cardHash == null || cardHash === "") {
								throw "Não foi possivel gerar o card hash";
							}
							getRecaptcha(form);
						});
					}
				} catch (error) {
					console.error(error);
					return false;
				}

			} else {
				getRecaptcha(form);
			}
		} else {
			pageLoadingOff();
		}
	});

	$('#form-identifique-se div.radio label').change(function () {
		var opcao = $('#form-identifique-se div.radio label input[name=opcao]:checked').val();
		if (opcao == 2) {
			$('#form-identifique-se div.identificacao').removeClass("notvisible");
		} else {
			$.ajax({
				type: "POST",
				url: "",
				data: "identificacao=1&register=ok",
				dataType: "json",
				success: function (json) {
					$("#checkout-user").html(json.html);
				}
			});
		}
	});

	/**
	* Altera a forma de pagamento
	*/
	$('#change-payment').click(function () {
		if ($("#change-payment-content").hasClass("displaynone")) {
			$("#change-payment-content").removeClass("displaynone");
		} else {
			$("#change-payment-content").addClass("displaynone");
		}
	});

	/**
	* Listagem dos produtos no carrinho
	*/
	$(document).on('click', '.checkout .hide-products > button', function () {
		if ($(this).parent().hasClass('show-products')) {
			$(this).parent().removeClass('show-products');
			$('.purchase-list-resume-items').fadeIn();
			$('.purchase-list-resume .subtotal').css({ "display": "table-cell" }).animate({ opacity: 1 });
			$('.purchase-list-resume .amount').css({"display":"table-cell"}).animate({opacity:1});
			// $('.purchase-list-resume .amount').addClass("d-none");
			$('.purchase-list-resume .amount').addClass('d-table-cell');
			$(this).html('<span class="setacima"></span> <span class="d-none d-md-inline-block">Ocultar produtos</span>');
			reloadicons("setacima");
		} else {
			$(this).parent().addClass('show-products');
			$('.purchase-list-resume-items').fadeOut();
			$('.purchase-list-resume .subtotal').css({ "display": "none" }).animate({ opacity: 0 });
			$('.purchase-list-resume .amount').css({ "display": "none" }).animate({ opacity: 0 });
			$(this).html('<span class="setabaixo"></span> <span class="d-none d-md-inline-block">Ver todos os produtos</span>');
			reloadicons("setabaixo");
		}
	});

	/**
	* Abrir e fechar os passos
	*/
	$('.checkout .toggle-step').click(function () {
		var minHeight = $(this).parent().outerHeight();
		if (!$(this).parent().parent().hasClass('closed')) {
			$(this).parent().parent().addClass('closed');
			//$(this).parent().parent().addClass('closed').animate({'height':minHeight,'min-height':minHeight});
		} else {
			$(this).parent().parent().removeClass('closed')
			//$(this).parent().parent().removeClass('closed').animate({'height':"inherit",'min-height':680});
		}
	});

	/**
	* Step 1
	*/
	// Fazer lougout pelo checkout
	// Abre o modal para atualizar o cadastro
	$('.checkout .editar-cadastro-checkout').click(function () {
		$.ajax({
			type: "POST",
			url: "",
			data: "getPerson=1",
			dataType: "json",
			success: function (json) {
				if (json.success != undefined) {
					$('body').prepend(json.success);
					showOverlay("overlay-person-update");
				} else if (json.error != undefined) {
					alert(json.error);
				}
			}
		});
	});

	// Abre o modal para incluir a I.E.
	$('.checkout').on("click", "#iedit", function () {
		$.ajax({
			type: "POST",
			url: "",
			data: "iedit=1",
			dataType: "json",
			success: function(json){
				if(json.success != undefined){
					$('body').prepend(json.success);
					showOverlay("overlay-ie-update");
				}else if (json.error != undefined){
					alert(json.error);
				}
			}
		});
	});

	$('.checkout').on("click", "#overlay-ie-update button.close", function (e) {
		const modal = new Modal(document.getElementById("overlay-ie-update"));
		modal.hide();
	});

	/**
	* Step 2
	*/
	if ($(".checkout #addressSelect option.selected").length == 1) {
		selectAddress($("#addressSelect option.selected").val());
	} else if ($(".checkout #addressSelect option").length == 1) {
		selectAddress($("#addressSelect option").val());
	} else {
		$(".checkout #carriers").addClass("displaynone");
		$(".checkout #step-3 .step-content").addClass("displaynone");
	}
	// Selecionar outro endereço
	$("body.checkout").on("change", ".address-place select", function () { selectAddress($(this).val()); });
	// Novo endereço no checkout
	$("body.checkout").on("click", ".novo-endereco-checkout", formNewAddress);
	// Editar endereço no checkout
	$("body.checkout").on("click", ".editar-endereco-checkout", formEditAddress);
	// Cancela a edição do endereço
	$("body.checkout").on("click", "button.cancelar", function () {
		var currAddress = "";
		if ($("#addressSelect option.selected").length == 1) {
			currAddress = $("#addressSelect option.selected").val();
		} else if ($("#addressSelect option").length > 1) {
			currAddress = $($("#addressSelect option").get(1)).val();
		}
		if (currAddress != "") {
			$("#addressSelect").val(currAddress);
			$("#addressSelect").trigger("change");
		} else {
			pageLoadingOn();
			window.location.reload(true);
		}
	});
	// Selecionar outra transportadora
	$("body.checkout").on("change", ".carriers-content input", function () {
		var carrierId = $(this).val()
		$('.carriers-content label').removeClass('checked');
		$(this).parent().addClass('checked');
		$('#payments-accordion').html('');
		pageLoadingOn();
		$.ajax({
			type: "POST",
			url: "",
			data: "changeCarrier=" + carrierId,
			dataType: "json",
			success: async function (json) {
				var recalcular = false; // calcula o desocnto ou juros se tiver alguma forma de pagamento selecionada ou combo de parcelamento
				if (json.error != undefined) {
					alert(json.error);
				} else {
					window.TransactionInfo = json.values;
					$('#payments-accordion').html(json.paymentsAccordion);
					$('#payments-accordion h5[data-open=true]').trigger('click');
					await import('./mkx-mask.js');
					await import('./mkx-validator.js');
					if ($("select[name=nparcels]").length > 0) {
						if ($("select[name=nparcels]").val() != null) {
							var tmp = $("select[name=nparcels]").val().split("_");
							if (tmp.length > 1) {
								if (tmp[1] != 0) {
									recalcular = true;
									$("select[name=nparcels]").trigger('change');
								}
							}
						}
					}
					if (!recalcular) {
						if ($("input:checked[name=payment]").length > 0) {
							recalcular = true;
							$("input:checked[name=payment]").trigger('click');
						}
					}
					if (!recalcular) {
						for (var i in json.values) {
							if (json.values[i] == "0,00" && i != "shipping") { //frete mostra mesmo com 0,00
								$('.resume #' + i + " span strong").html("");
								$('.resume #' + i).addClass("displaynone");
							} else {
								$('.resume #' + i + " span strong").html(json.values[i]);
								$('.resume #' + i).removeClass("displaynone");
							}
						}
						/* Mercado Pago Transparente */
						const formsPaymentsCard = document.querySelectorAll("form.form-payment-gateway-card");
						if (formsPaymentsCard && formsPaymentsCard.length > 0) {
							Array.from(formsPaymentsCard).forEach((formPaymentCard) => {
								const totalInput = formPaymentCard.querySelector("input#total_value");
								if (totalInput && json.values.total) {
									totalInput.value = json.values.total.replace('.', '').replace(',', '.');
								}
							});
						}
						/* END Mercado Pago Transparente */
					}
					loadCardForms();
					loadWallets(json.values.totalOrder);
					dispatchCheckoutEvents(json.values.totalProduct);
				}
				pageLoadingOff();
			},
			error: function () {
				$('.carriers-content label').removeClass('checked');
				pageLoadingOff();
			}
		});
	});

	/**
	* Step 3
	*/
	// Accordion - Checkout (Selecionar forma de pagamento)
	$(document).on('click', '.payments h5', function () {
		$('#step-3 .payments h5 span').removeClass('setacima');
		$('#step-3 .payments h5 span').addClass('setabaixo');

		$("#change-payment-content .payments h5 span").removeClass("setacima");
		$("#change-payment-content .payments h5 span").addClass("setabaixo");

		reloadicons('setabaixo');

		$('.payments h5').removeClass('on');
		$('.payments h5').next().slideUp();
		if ($(this).next().is(':visible')) {
			$(this).removeClass('on');
			$(this).next().slideUp();
			if ($(this).hasClass('on')) {
				$(this).children('span').addClass('setacima');
				reloadicons('setacima');
			} else {
				$('#step-3 .payments h5 span').removeClass('setacima');
				$('#step-3 .payments h5 span').addClass('setabaixo');

				$("#change-payment-content .payments h5 span").removeClass("setacima");
				$("#change-payment-content .payments h5 span").addClass("setabaixo");

				reloadicons('setabaixo');
			}
		} else {
			if ($(this).parent().find('input[name=payment]').length == 1) {
				$(this).parent().find('input[name=payment]').trigger('click');
			}
			$('.payments .accordion h5').removeClass('on');
			$('.payments .accordion h5').next().slideUp();
			$('.payments .accordion h5').next().find('.payment-data').html('');
			$('.payments .accordion input[name=payment]').removeAttr('checked');
			$(this).addClass('on');
			$(this).next().slideDown();
			if ($(this).hasClass('on')) {
				$(this).children('span').addClass('setacima');
				reloadicons('setacima');
			} else {
				$('#step-3 .payments h5 span').removeClass('setacima');
				$('#step-3 .payments h5 span').addClass('setabaixo');

				$("#change-payment-content .payments h5 span").removeClass("setacima");
				$("#change-payment-content .payments h5 span").addClass("setabaixo");

				reloadicons('setabaixo');
			}
		}

		//se tem somente uma forma de pagamento já seleciona
		var i = $(this).index('.payments h5');
		var ele = $($('div.payment').get(i));
		if (ele.find("input[name=payment]").length == 1) {
			$(ele).find("input[name=payment]").trigger('click');
		} else if ($("input[name=payment]:checked").length == 1) {
			$("input[name=payment]").checked = false;
		}
	});

	// Seleciona o mercado pago
	$('.payments h5.mercadopago').click(function () {
		$.ajax({
			type: "POST",
			url: "",
			data: "paymentId=40",
			dataType: "json",
			success: function (json) {
				if (json.error != undefined) {
					alert(json.error);
				} else {
					for (var i in json.values) {
						if (json.values[i] == "0,00" && i != "shipping") { //frete mostra mesmo com 0,00
							$('.resume #' + i + " span strong").html("");
							$('.resume #' + i).addClass("displaynone");
						} else {
							$('.resume #' + i + " span strong").html(json.values[i]);
							$('.resume #' + i).removeClass("displaynone");
						}
					}
				}
				pageLoadingOff();
			}
		});
	});

	// Selecionar a forma de pagamento
	$("body.checkout").on("click", "#step-3 input[name=payment]", function () {
		pageLoadingOn();
		var label = $(this);
		var paymentId = $(this).val();
		$.ajax({
			type: "POST",
			url: "",
			data: "paymentId=" + paymentId,
			dataType: "json",
			success: function (json) {
				if (json.error != undefined) {
					alert(json.error);
				} else {
					if (label.is(':visible')) {
						label.parent().parent().find('.payment-data').html(json.payment);
					}
					for (var i in json.values) {
						if (json.values[i] == "0,00" && i != "shipping") { //frete mostra mesmo com 0,00
							$('.resume #' + i + " span strong").html("");
							$('.resume #' + i).addClass("displaynone");
						} else {
							$('.resume #' + i + " span strong").html(json.values[i]);
							$('.resume #' + i).removeClass("displaynone");
						}
					}
				}
				pageLoadingOff();
			}
		});
	});
	// Selecionar a forma de pagamento no mudar pagamento, tela do pedido
	$("body.purchase-order").on("click", "input[name=payment]", function () {
		pageLoadingOn();
		var label = $(this);
		var paymentId = $(this).val();
		var order_id = $("input[name=order_id]").val();
		$.ajax({
			type: "POST",
			url: "/finalizar-compra/",
			data: "paymentId=" + paymentId + "&order_id=" + order_id,
			dataType: "json",
			success: function (json) {
				if (json.error != undefined) {
					alert(json.error);
				} else if (label.is(':visible')) {
					label.parent().parent().find('.payment-data').html(json.payment);
				}
				pageLoadingOff();
			}
		});
	});
	// Seleciona o combo do parcelamento
	$("body.checkout").on("change", "#step-3 select[name=nparcels]", function () {
		pageLoadingOn();
		var label = $(this);
		var paymentId = $("input[name=paymentId]").val();
		var nparcels = $(this).val();
		$.ajax({
			type: "POST",
			url: "",
			data: "paymentId=" + paymentId + "&nparcels=" + nparcels,
			dataType: "json",
			success: function (json) {
				if (json.error != undefined) {
					alert(json.error);
				} else {
					for (var i in json.values) {
						if (json.values[i] == "0,00" && i != "shipping") { //frete mostra mesmo com 0,00
							$('.resume #' + i + " span strong").html("");
							$('.resume #' + i).addClass("displaynone");
						} else {
							$('.resume #' + i + " span strong").html(json.values[i]);
							$('.resume #' + i).removeClass("displaynone");
						}
					}
				}
				pageLoadingOff();
			}
		});
	});

	$("body.checkout").on("click", ".btn-comprar", function (e) {
		var vDe = $('#gift-info input[name="de"]').val();
		var vPara = $('#gift-info input[name="para"]').val();
		var vMensagem = $('#gift-info textarea[name="mensagem"]').val();

		if (vDe != undefined && vDe != '') {
			$('input[name="from"]').val(vDe);
		}

		if (vPara != undefined && vPara != '') {
			$('input[name="to"]').val(vPara);
		}

		if (vMensagem != undefined && vMensagem != '') {
			$('input[name="message"]').val(vMensagem);
		}
	});


	$(document).on('click', "#temp-login", function(e){
		const form  = $(this).closest("form");
		$.ajax({
			type: "POST",
			url: "/finalizar-compra/",
			data: "tempLogin=true",
			dataType: "json",
			success: function (json) {
				if(json.location){
					window.location.href = json.location
				}
			}
		});
		
	})
});



function dispatchCheckoutEvents(value) {
	value = parseFloat(value.replace('.', '').replace(",", '.'));
	const shipping = document.querySelector(".carriers.purchase-list-carriers label.checked")?.querySelector(".name")?.textContent;
	if(shipping === 'Retirar na Loja') {
		$('.checkout .location-delivery').addClass('active')
	}else {
		$('.checkout .location-delivery').removeClass('active')
	}
	if (shipping) {
		dispatchAddShippingInfoEvent({ shipping, value });
	}
	document.querySelectorAll("#payments-accordion form button")?.forEach(button => {
		button.addEventListener("click", e => {
			const paymentName = e.target.getAttribute("data-paymentname");
			if (paymentName) dispatchAddPaymentInfoEvent({ paymentName, value });
		});
	});
}

// Selecionar o endereço, passo 2
function selectAddress(addressId) {
	if (addressId == "" || addressId == undefined) {
		formNewAddress();
	} else {
		pageLoadingOn();
		$("#carriers").removeClass("displaynone");
		$("#address-block").removeClass("displaynone");
		$("#address-insert").html("");
		$("#addressSelect option").removeClass("selected");
		$("#addressSelect option:selected").addClass("selected");
		$("#payments-accordion").html("");
		$.ajax({
			type: "POST",
			url: "",
			data: "changeAddress=" + addressId,
			dataType: "json",
			timeout: 20000, // 20 segundos de espera
			success: function (json) {
				window.TransactionInfo = json.values;
				$('div#carriers div.carriers-content').html(json.carriers);
				for (var i in json.values) {
					if ((json.values[i] == "0,00" || json.values[i] == "-0,00") && i != "shipping") {
						$('.resume #' + i + " span strong").html("");
						$('.resume #' + i).addClass("displaynone");
					} else {
						$('.resume #' + i + " span strong").html(json.values[i]);
						$('.resume #' + i).removeClass("displaynone");
					}
				}
				pageLoadingOff();
				if (json.numberOfCarriers == 0) return;
				$("#step-2 .step").removeClass("step-on");
				$("#step-3 .step").addClass("step-on");
				$("#step-3 .step-content").removeClass("displaynone");
				$('#payments-accordion').html(json.paymentsAccordion);
				$('#payments-accordion h5[data-open=true]').trigger('click');
				$('div#address-block').html(json.address);
				reloadicons();
				loadCardForms();
				loadWallets(json.values.totalOrder);
				//se só tem uma opção, já deixa selecionada
				if ($("body.checkout .payments h5.on").length == 1 && $("body.checkout .payments h5.on").next().find("input[name=payment]").length == 1) {
					$("body.checkout .payments h5.on").next().find("input[name=payment]").trigger('click');
				}

				dispatchCheckoutEvents(json.values.totalProduct);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				if (textStatus === "timeout") {
					pageLoadingOff();
					bootbox.dialog({
						message: "Desculpe, houve uma instabilidade, a página será recarregada, favor tente novamente",
						title: "Instabilidade no servidor",
						buttons: {
							success: {
								label: "Ok",
								className: "btn-success",
								callback: function () {
									window.location.reload(true);
								}
							}
						}
					});
				}
			}
		});
	}
}

//novo endereço, passo 2
function formNewAddress() {
	pageLoadingOn();
	$("#step-2 .step").addClass("step-on");
	$("#step-3 .step").removeClass("step-on");
	$("#step-3 .step-content").addClass("displaynone");
	$.ajax({
		type: "POST",
		url: "",
		data: "formNewAddress=1",
		dataType: "json",
		success: function (json) {
			if (json.html != "") {
				$("#address-insert").html(json.html);
				$("#carriers").addClass("displaynone");
				$("#address-block").addClass("displaynone");
				$("#addressSelect").val("");
				setZipcodeTypingFormatter();
			} else if (json.error != undefined) {
				alert(json.error);
			}
			pageLoadingOff();
		}
	});
}

//editar endereço, passo 2
function formEditAddress() {
	pageLoadingOn();
	$("#step-2 .step").addClass("step-on");
	$("#step-3 .step").removeClass("step-on");
	$("#step-3 .step-content").addClass("displaynone");
	var id = $(this).attr("rel");
	$.ajax({
		type: "POST",
		url: "",
		data: "formEditAddress=1&id=" + id,
		dataType: "json",
		success: function (json) {
			if (json.html != "") {
				$("#address-insert").html(json.html);
				$("#carriers").addClass("displaynone");
				$("#address-block").addClass("displaynone");
				window.actualCity = json.city_id;
				$(".state select").trigger('change');
				pageLoadingOff();
			} else if (json.error != undefined) {
				pageLoadingOff();
				alert(json.error);
			}
		}
	});
}

function clearPayments() {
	$('div.payments input[type="radio"]').each(function () {
		$(this).prop('checked', false);
	});
	$("div.payment-data").html("");
	$("label.wirecard-label input[name=payment]").trigger('click');
}

function getRecaptcha(form) {
	if (form.find("input[name=g-recaptcha-response]").length == 1) {
		//Google reCAPTCHA v3
		// event.preventDefault();
		var gInput = form.find("input[name=g-recaptcha-response]");
		var site_key = gInput.attr("data-sitekey");
		var action_name = gInput.attr("data-action");
		grecaptcha.ready(function () {
			grecaptcha.execute(site_key, { action: action_name })
				.then(function (token) {
					gInput.val(token);
					$(form).submit();
				});
		});
		//FIM Google reCAPTCHA v3
	}
}

$(document).on('click', '#btn-checkout-coupon', function (e) {
    e.preventDefault();
    pageLoadingOn();
    var cupom = $('#checkout-coupon-input').val();
    
    $.ajax({
        type: "POST",
        url: "/carrinho-de-compra/",
        data: { coupon: cupom, addCoupon: 1 },
        dataType: 'json',
        success: function (response) {
            if (response.error) {
                $('.checkout-coupon .alert').remove();
                $('.checkout-coupon .insert-coupon').append('<div class="w-100 mt-2 alert alert-danger" role="alert"><span class="iconwarning"></span>' + response.data + '</div>');
                pageLoadingOff();
            } else {
                var successHtml = '<div class="w-100 mt-2 alert alert-success d-flex justify-content-between align-items-center"><span>' + response.data + '</span><button type="button" class="btn btn-coupon-remove-link">(REMOVER)</button></div>';
                sessionStorage.setItem('couponSuccess', successHtml);
                window.location.reload();
            }
        },
        error: function() {
            window.location.reload();
        }
    });
});

$(document).on('keypress', '#checkout-coupon-input', function (e) {
    if (e.keyCode == 13) {
        e.preventDefault();
        $('#btn-checkout-coupon').click();
    }
});

$(document).on('click', '.checkout-coupon .btn-coupon-remove-link', function (e) {
    e.preventDefault();
    pageLoadingOn();
    $.ajax({
        type: "POST",
        url: "/carrinho-de-compra/",
        data: { calculate: 1, removeCoupon: 1 },
        success: function () {
            window.location.reload();
        },
        error: function() {
            window.location.reload();
        }
    });
});

$(document).ready(function() {
    if (sessionStorage.getItem('couponSuccess')) {
        $('.checkout-coupon .alert').remove();
        $('.checkout-coupon .insert-coupon').append(sessionStorage.getItem('couponSuccess'));
        sessionStorage.removeItem('couponSuccess');
    }
    if (sessionStorage.getItem('couponWarning')) {
        $('.checkout-coupon .alert').remove();
        $('.checkout-coupon .insert-coupon').append(sessionStorage.getItem('couponWarning'));
        sessionStorage.removeItem('couponWarning');
    }
});